import { render, staticRenderFns } from "./sboMatchInfo.vue?vue&type=template&id=086941af&scoped=true&lang=pug&"
import script from "./sboMatchInfo.vue?vue&type=script&lang=js&"
export * from "./sboMatchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086941af",
  null
  
)

export default component.exports